import React, { useEffect, useState } from "react";
import I18n from "../../../localization/index.js";
import { Box, Button, Checkbox, Typography, CircularProgress } from "@material-ui/core";
import { makeStyle } from "./setupAirDeviceStyles.js";
import Icon from '../../../utils/icons.js'
import * as BleApi from "../../../utils/bleApi.js";
import PubSub from "pubsub-js";
import _ from "lodash";
import { EVSE_NATIVE_METHODS, PAGES } from "../../../utils/constant.js";
import { Header } from "../../../components/Header/index.js";
import CustomDrawer from "../../../components/Drawer/index.js";
import * as utility from "../../../utils/utility.js";
import { PopUp } from "../../../components/index.js";

const AirDeviceSetup = (props) => {
    const IQ_AIR_MODEL = {
      IQ_AIR_HUB: {
        ID: 'IQ_AIR_HUB',
        HEADER_TITLE: I18n.t('mobile.AirDeviceProvisioning.addIQAirHubTitle'),
        INST_HEADING: '',
        INST_LINE_1: I18n.t('mobile.AirDeviceProvisioning.instructionsLi1A'),
        INST_LINE_2: I18n.t('mobile.AirDeviceProvisioning.instructionsLi2A'),
        INST_LINE_3A: '',
        INST_LINE_3B: '',
        INST_LINE_4A : '',
        INST_LINE_4B : '',
        CONSENT_TEXT: I18n.t('mobile.AirDeviceProvisioning.tncCheckAsk'),
        SETUP_HEADING: I18n.t("mobile.AirDeviceProvisioning.comissioningHeading1A"),
        SETUP_SUBHEADING: I18n.t("mobile.AirDeviceProvisioning.comissioningSubHeading1A"),
        SETUP_SUCCESS_HEADING: I18n.t("mobile.AirDeviceProvisioning.comissioningHeading2A"),
        SETUP_SUCCESS_SUBHEADING: '',
        SETUP_FAIL_HEADING: I18n.t("mobile.AirDeviceProvisioning.comissioningHeadingFail"),
        SETUP_FAIL_HEADINGA1: I18n.t("mobile.AirDeviceProvisioning.comissioningHeadingFailA1"),
        SETUP_FAIL_HEADINGA2: I18n.t("mobile.AirDeviceProvisioning.comissioningHeadingFailA2"),
        DEVICE_TYPE: I18n.t("mobile.AirDeviceProvisioning.iqAirPrimary"),
      },
      IQ_AIR_DISPLAY: {
        ID: 'IQ_AIR_DISPLAY',
        HEADER_TITLE: I18n.t('mobile.AirDeviceProvisioning.addIQAirDisplayTitle'),
        INST_HEADING: I18n.t('mobile.AirDeviceProvisioning.instSubHeading2'),
        INST_LINE_1: I18n.t('mobile.AirDeviceProvisioning.instructionsLi1B'),
        INST_LINE_2: I18n.t('mobile.AirDeviceProvisioning.instructionsLi2B'),
        INST_LINE_3A: I18n.t('mobile.AirDeviceProvisioning.instructionsLi3A'),
        INST_LINE_3B: I18n.t('mobile.AirDeviceProvisioning.instructionsLi3B'),
        INST_LINE_4A : I18n.t('mobile.AirDeviceProvisioning.instructionsLi4A'),
        INST_LINE_4B : I18n.t('mobile.AirDeviceProvisioning.instructionsLi4B'),
        CONSENT_TEXT: I18n.t('mobile.AirDeviceProvisioning.tncCheck'),
        SETUP_HEADING: I18n.t("mobile.AirDeviceProvisioning.comissioningHeading1B"),
        SETUP_SUBHEADING: I18n.t("mobile.AirDeviceProvisioning.comissioningSubHeading1B"),
        SETUP_SUCCESS_HEADING: I18n.t("mobile.AirDeviceProvisioning.comissioningHeading2B"),
        SETUP_SUCCESS_SUBHEADING: I18n.t("mobile.AirDeviceProvisioning.comissioningSubHeading2B"),
        DEVICE_TYPE: I18n.t("mobile.AirDeviceProvisioning.iqAirSecondary"),
      }
    }
    const {onGoBack, handleClick, iqAirModel, siteId} = props
    const classes = makeStyle();
    const [checked, setChecked] = useState(false);
    const [cameraAllowed, setCameraAllowed] = useState(false);
    const [cameraPermissionGranted, setCameraPermissionGranted] = useState(false);
    const [loadingPermission, setLoadingPermission] = useState(false);
    const [isInfoOpen, setIsInfoOpen] = useState(false);
    const [capturedImage, setCapturedImage] = useState(null);
    useEffect(() => {
        const savedPermission = localStorage.getItem("cameraPermissionGranted");
        if (savedPermission === "true") {
            setCameraAllowed(true);
            setCameraPermissionGranted(true);
        }
        if(iqAirModel === IQ_AIR_MODEL.IQ_AIR_DISPLAY.ID){
            setCameraAllowed(true);
        }
    }, []);


    const checkCameraPermission = () => {
        setLoadingPermission(true);

        if (utility.isiOS()) {
            setCameraAllowed(true);
            localStorage.setItem("cameraPermissionGranted", "true");
            setLoadingPermission(false);
            return;
        }

        const handleCameraStatus = (event, data) => {
            const cameraStatus = (data?.data && !_.isEmpty(data.data) && data.data) || "0";

            if (cameraStatus === "1") {
                setCameraAllowed(true);
                localStorage.setItem("cameraPermissionGranted", "true");
                PubSub.unsubscribe(EVSE_NATIVE_METHODS.DID_GOT_CAMERA_PERMISSIONS);
            } else {
                alert(I18n.t('mobile.AirDeviceProvisioning.cameraAccessDenied'));
            }
            setLoadingPermission(false);
        };

        PubSub.subscribe(EVSE_NATIVE_METHODS.DID_GOT_CAMERA_PERMISSIONS, handleCameraStatus);
        BleApi.requestCameraPermission();
    };

    return (
        <>
            <Header title={IQ_AIR_MODEL[iqAirModel].HEADER_TITLE} onClick={onGoBack} />
            <Box className={!siteId ? classes.siteSetupContainerNewUser : classes.siteSetupContainer}>
                <Box className={classes.siteSetupDetails}>
                    <Typography className={classes.siteSetupHeader}>{I18n.t('mobile.AirDeviceProvisioning.instructions')}</Typography>
                    {/* {IQ_AIR_MODEL[iqAirModel].INST_HEADING && <span className={classes.siteSetupSubheading}>&nbsp;{IQ_AIR_MODEL[iqAirModel].INST_HEADING}</span>} */}
                    {/* <ol className={classes.instructionFormate}>
                        <li>
                            {IQ_AIR_MODEL[iqAirModel].INST_LINE_1}
                           
                        </li>
                        <li>
                            {IQ_AIR_MODEL[iqAirModel].INST_LINE_2}
                            {IQ_AIR_MODEL[iqAirModel].INST_LINE_3A && IQ_AIR_MODEL[iqAirModel].INST_LINE_3B && <>
                                <br />
                                {IQ_AIR_MODEL[iqAirModel].INST_LINE_3A}
                                <br />
                                {IQ_AIR_MODEL[iqAirModel].INST_LINE_3B}
                            </>}
                            {IQ_AIR_MODEL[iqAirModel].INST_LINE_4A && IQ_AIR_MODEL[iqAirModel].INST_LINE_4B && <>
                                <br />
                                {IQ_AIR_MODEL[iqAirModel].INST_LINE_4A}
                                <br />
                                {IQ_AIR_MODEL[iqAirModel].INST_LINE_4B}
                            </>}
                        </li>
                    </ol> */}

                    <span className={classes.siteSetupSubheading}>
                        <ol className={`${classes?.numberedList} ${classes?.numberedListNone}`}>
                                            <li dangerouslySetInnerHTML={{__html: I18n.t('mobile.AirDeviceProvisioning.installStep1Primary', { defaultValue: '1. Have your Serial ID ready: Find it on the device box or insert card.' })}}></li>
                                            <li dangerouslySetInnerHTML={{__html: I18n.t('mobile.AirDeviceProvisioning.installStep2Primary', { defaultValue: '2. Link to Enlighten: Add your IQ Air to the Enlighten app first.' })}}></li>
                                            <li dangerouslySetInnerHTML={{__html: I18n.t('mobile.AirDeviceProvisioning.installStep3Primary', { defaultValue: '3. Install: Detailed wiring and installation guides will follow.' }),
                            }}></li>
                                        </ol>
                    </span>

                    {iqAirModel === IQ_AIR_MODEL.IQ_AIR_HUB.ID &&
                    <>
                        <Box className={classes.siteSetupSettings}>
                            <Box className={classes.infoIconContainer}>
                                <Typography>{I18n.t('mobile.AirDeviceProvisioning.additionalSettings')}</Typography>
                                <span onClick={() => setIsInfoOpen(true)}>
                                    <Icon src="infoIcon" />
                                </span>
                            </Box>

                            <Typography className={classes.siteSetupSubHeader}>
                                {I18n.t('mobile.AirDeviceProvisioning.provideCameraPermission')}
                            </Typography>
                        </Box>

                        <Box className={classes.cameraPermissionBox}>
                            <Box className={classes.permissionTextBox}>
                                <span className={classes.icon}>
                                    <Icon src={cameraAllowed ? "successTick" : "warningInfo"} />
                                </span>
                                <Typography className={classes.cameraPermission}>
                                    {I18n.t('mobile.AirDeviceProvisioning.cameraAccess')}
                                </Typography>
                            </Box>

                            {!cameraAllowed && (
                                <Button
                                    className={classes.permissionButton}
                                    variant="outlined"
                                    color="primary"
                                    onClick={checkCameraPermission}
                                    disabled={loadingPermission}
                                >
                                    {loadingPermission ? (
                                        <CircularProgress className={classes.customCircularLoader} size={18} color="primary" />
                                    ) : (
                                        I18n.t('mobile.common.allowBtn')
                                    )}
                                </Button>
                            )}
                        </Box>
                    </>}
                </Box>

                <Box className={classes.tnc}>
                    <Checkbox
                        checked={checked}
                        onChange={(e) => setChecked(e.target.checked)}
                        color="primary"
                    />
                    <Typography className={classes.tncDescription}>
                        {IQ_AIR_MODEL[iqAirModel].CONSENT_TEXT}
                    </Typography>
                </Box>

                <Box className={classes.buttonContainer}>
                    <Button
                        className={classes.continueButton}
                        disabled={!checked || !cameraAllowed}
                        onClick={() => handleClick(iqAirModel === IQ_AIR_MODEL.IQ_AIR_HUB.ID ? PAGES.CONFIRM_SITE : PAGES.LINK_HVAC_TO_THERMOSTAT)}
                    >
                        {I18n.t('mobile.common.letsGetStarted')}
                    </Button>
                </Box>
            </Box>

            <PopUp
                open={isInfoOpen}
                content={
                    <CustomDrawer
                        dismiss={() => setIsInfoOpen(false)}
                        message={
                            <>
                                <span>{I18n.t('mobile.AirDeviceProvisioning.cameraAccess')}</span>
                                <br />
                                {I18n.t('mobile.AirDeviceProvisioning.instructionDrawerContent')}
                            </>
                        }
                        isDrawer={true}
                        title={I18n.t('mobile.AirDeviceProvisioning.instructionDrawerTitle')}
                    />
                }
            />
        </>
    );
};

export default AirDeviceSetup;
